import type { MarketExceptionType } from '../../MarketExceptionTypes'

export const PR: MarketExceptionType = {
  hasStoreCredit: false,
  marketoSmsOptIn: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: false,
    required: false,
  },
  checkoutTermsAndConditionsStatement: true,
  disableAccountPaymentMethods: false,
  currencyCode: 'USD',
  creditCardProvidersSupported: ['MC', 'VI', 'AX', 'DI'],
  isWorldPay3DS: false,
  poboxRestricted: true,
  isPickupMarket: true,
  hasAddressRegion: false,
  allowShippingToExternalCountries: false,
  supportsStoreCredit: true,
  applePayOTP: true,
  applePaySubscriptions: false,
  hasPaypal: true,
  hasPaypal3DS: false,
  hasShipByDate: false,
  hasAddressValidation: true,
  allowSubscriptionPickup: false,
  hasProductAvailability: true,
  hasZipCode: true,
  skuAvailabilityShippingMethod: 'Economy - Islandwide',
  defaultEconomyShippingMethod: 'Economy',
  reportIssueButton: {
    show: true,
    url: {
      en: 'https://docs.google.com/forms/d/e/1FAIpQLSeSQ-I2Ggxb3st3pjunEs0kYjGYLGyM8uH9sM2Fl_cHmyFMaQ/viewform',
      es: 'https://docs.google.com/forms/d/e/1FAIpQLSfELdzaFq8EOVbTA5JLG2m8j3L6jCgVDpHY8rbfNEzrJdfSCA/viewform?usp=sf_link',
    },
  },
  skuPricingOverrides: [
    '33643',
    '33696',
    '33694',
    '33695',
    '34274',
    '34273',
    '34272',
    '35006',
    '35611',
    '35085',
    '35084',
    '35083',
    '35082',
    '35081',
    '35080',
    '35043',
    '35668', // FeelGreat Fresh Lime
    '35678', // FeelGreat Apple Crush
    '35735', // FeelGreat Apple Crush - Lemon Ginger
    '35753', // FeelGreat Mixed Berry - Lemon
    '35754', // FeelGreat Mixed Berry - Lemon Ginger
    '35082', // FG 10 Pack Lemon - no box, no bottle
    '35083', // FG 10 Pack Lemon Ginger - no box, no bottle
    '35084', // FG 10 Pack Lemon & Lemon Ginger - no box, no bottle
    '35999', // FG Apple Spice 10-pack
    '36004', // FG Apple Spice 10-pack - no box, no bottle
    '35882',
    '35883',
    '35884',
    '35885',
    '35886',
    '35887',
    '35934',
    '35935',
    '35936',
    '35937',
    '35938',
    '35939',
    '35961',
    '35965',
    '35960',
    '35954',
    '35955',
    '35957',
    '36155',
    '36153',
    '36154',
    '36149',
    '36148',
    '36150',
    '36150',
    '35999',
    '35956', // apple berry premium
    '36004', // apple orange
    '35962', // apple berry
    '36005', // apple ginger orange
    '36006', // apple lemon orange
    '35963', // berry ginger apple,
    '35964', // lemon apple berry
    '35963', // ginger apple berry
    '35959',
    '35958',
    '35956',
  ],
  isUlabsAvailable: true,
}
